import AuthLayout from "components/layout/AuthLayout";
import Layout from "components/layout/Layout";
import { RoleGaurd } from "components/layout/RoleGaurd";
import UiKitLayout from "components/layout/UiKitLayout";
import Loadable from "lib/suspenseLoader/Loadable";
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

import { PATHS } from "configs/routeConfig";

import GuestRoute from "./GuestRoutes";
import PrivateRoute from "./PrivateRoutes";

// import PrivateRoute from "./PrivateRoutes"Select All Permissions;

/** Auth */
const Login = Loadable(lazy(() => import("modules/auth/login/Login")));
const OtpDetails = Loadable(
  lazy(() => import("modules/auth/otpVerification/OtpDetails"))
);
const OtpVerification = Loadable(
  lazy(() => import("modules/auth/otpVerification/OtpVerification"))
);
const ForgotPassword = Loadable(
  lazy(() => import("modules/auth/forgotPassword/ForgotPassword"))
);
const DeleteAccount = Loadable(
  lazy(() => import("modules/auth/deleteAccount/DeleteAccount"))
);
const PrivacyPolicy = Loadable(
  lazy(() => import("modules/auth/privacyPolicy/PrivacyPolicy"))
);
const TermsAndConditions = Loadable(
  lazy(() => import("modules/auth/termsAndConditions/TermsAndConditions"))
);
const ResetPassword = Loadable(
  lazy(() => import("modules/auth/resetPassword/ResetPassword"))
);

/** Dashboard */
const Dashboard = lazy(() => import("modules/dashboard/Dashboard"));

/** User Management*/
const UserManagement = lazy(() =>
  import("modules/userManagement/UserManagement")
);
const UserList = Loadable(
  lazy(() => import("modules/userManagement/individualUserList/UserList"))
);
// const BusinessUserList = Loadable(
//   lazy(() => import("modules/userManagement/BusinessUserList/UserList"))
// );
// const BusinessUserPersonalDetails = Loadable(
//   lazy(() => import("modules/userManagement/BusinessUserList/PersonalDetails"))
// );
const AdminUsers = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AdminUsers"))
);
// const UserDetails = Loadable(
//   lazy(() => import("modules/userManagement/userDetails/ViewUserDetails"))
// );
const AddUser = Loadable(
  lazy(() => import("modules/userManagement/individualUserList/AddUser"))
);
const AdminUserDetails = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/ViewAdminUserDetails"))
);
// const ViewBusinessUserDetails = Loadable(
//   lazy(() =>
//     import("modules/userManagement/BusinessUserList/ViewBusinessUserDetails")
//   )
// );
const AdminUserAdd = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser"))
);
const AdminUserEdit = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser"))
);
/** Content Management*/
const ContentManagement = Loadable(
  lazy(() => import("modules/contentManagement/ContentManagement"))
);
const StaticPages = Loadable(
  lazy(() => import("modules/contentManagement/staticPages/StaticPages"))
);
const StatisPagesViewDetails = Loadable(
  lazy(() =>
    import("modules/contentManagement/staticPages/ViewStaticPageDetails")
  )
);
const AddStaticPage = Loadable(
  lazy(() =>
    import(
      "modules/contentManagement/staticPages/StaticPagesActions/AddStaticPage"
    )
  )
);

const FaqsPage = Loadable(
  lazy(() => import("modules/contentManagement/faq/Faq"))
);
const FaqsList = Loadable(
  lazy(() => import("modules/contentManagement/faq/faqList/FaqsList"))
);
const AddFaq = Loadable(
  lazy(() => import("modules/contentManagement/faq/faqList/faqActions/AddFaq"))
);

/** Role */
const RoleManagement = Loadable(
  lazy(() => import("modules/role/RoleManagement"))
);
const RolePage = Loadable(lazy(() => import("modules/role/Role")));
const AddEditRole = Loadable(lazy(() => import("modules/role/AddEditRole")));
const ViewRole = Loadable(lazy(() => import("modules/role/ViewRole")));

/** Email And Notifications */
const EmailTemplatesManagement = Loadable(
  lazy(() => import("modules/emailTemplates/EmailTemplatesManagement"))
);
const EmailTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/EmailTemplates"))
);
const AddEditTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/AddEditTemplates"))
);
const ViewTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/ViewTemplates"))
);

/** Lesg Logs */
const LesgLogs = Loadable(lazy(() => import("modules/lesgLogs/LesgLogs")));
const AddLogs = Loadable(lazy(() => import("modules/lesgLogs/AddLogs")));

/** Master Management */
const MasterManagement = Loadable(
  lazy(() => import("modules/masterManagement/MasterManagement"))
);
const CountryPage = Loadable(
  lazy(() => import("modules/masterManagement/country/Country"))
);
const AddCountry = Loadable(
  lazy(() => import("modules/masterManagement/country/AddCountry"))
);
const AmenitiesPage = Loadable(
  lazy(() => import("modules/masterManagement/amenities/Amenities"))
);

const RoleListPage = Loadable(
  lazy(() => import("modules/masterManagement/rolesList/RoleList"))
);
const AddRole = Loadable(
  lazy(() => import("modules/masterManagement/rolesList/AddRole"))
);

const PropertyTypePage = Loadable(
  lazy(() => import("modules/masterManagement/propertyType/PropertyType"))
);
const AddPropertyType = Loadable(
  lazy(() => import("modules/masterManagement/propertyType/AddPropertyType"))
);

const GemstoneTypePage = Loadable(
  lazy(() => import("modules/masterManagement/gemstoneType/GemstoneType"))
);
const SubsidiariesPage = Loadable(
  lazy(() => import("modules/masterManagement/subsidiaries/Subsidiaries"))
);
const AddAmenities = Loadable(
  lazy(() => import("modules/masterManagement/amenities/AddAmenities"))
);
const AddGemstoneType = Loadable(
  lazy(() => import("modules/masterManagement/gemstoneType/AddGemstoneType"))
);
const ViewGemsDetails = Loadable(
  lazy(() => import("modules/gemstones/gems/ViewGemsDetails"))
);
const AddSubsidiaries = Loadable(
  lazy(() => import("modules/masterManagement/subsidiaries/AddSubsidiaries"))
);

const AddLanguage = Loadable(
  lazy(() => import("modules/masterManagement/language/AddLanguage"))
);
const TimezonePage = Loadable(
  lazy(() => import("modules/masterManagement/timezone/Timezone"))
);
const LanguagePage = Loadable(
  lazy(() => import("modules/masterManagement/language/Language"))
);
const IndustryPage = Loadable(
  lazy(() => import("modules/masterManagement/industry/Industry"))
);
const AddIndustry = Loadable(
  lazy(() => import("modules/masterManagement/industry/AddIndustry"))
);

/** Support */
const SupportManagement = Loadable(
  lazy(() => import("modules/support/SupportManagement"))
);
const Support = Loadable(lazy(() => import("modules/support/Support")));
const TicketDetail = Loadable(
  lazy(() => import("modules/support/TicketDetails"))
);
/** Settings */
const Settings = Loadable(lazy(() => import("modules/settings/Settings")));
const GeneralSettings = Loadable(
  lazy(() => import("modules/settings/generalSettings/GeneralSettings"))
);
const NotificationsPage = Loadable(
  lazy(() => import("modules/settings/notifications/Notifications"))
);
const EmailNotifications = Loadable(
  lazy(() => import("modules/settings/emailNotifications/EmailNotifications"))
);
const PaymentGateway = Loadable(
  lazy(() => import("modules/settings/paymentGateway/PaymentGateway"))
);
const SmtpSmsDetails = Loadable(
  lazy(() => import("modules/settings/smtpSmsDetails/SmtpSmsDetails"))
);
const SocialMedia = Loadable(
  lazy(() => import("modules/settings/socialMedial/SocialMedia"))
);
const LanguageMessages = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/LanguageMessages"))
);
const AddLanguageMessages = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/AddLanguageMessage"))
);
const LangaugeStaticLang = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/LanguageStaticLang"))
);
const AddLanguageStaticLang = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/AddStaticLabel"))
);
/** Master Management */
// const CommonPages = Loadable(lazy(() => import("modules/commonPages/CommonPages")));
const FourZeroFourPage = Loadable(
  lazy(() => import("modules/commonPages/FourZeroFourPage"))
);
const ThankyouPage = Loadable(
  lazy(() => import("modules/commonPages/ThankyouPage"))
);
const ComingSoonPage = Loadable(
  lazy(() => import("modules/commonPages/ComingSoonPage"))
);

/** My Profile */
const MyProfile = Loadable(lazy(() => import("modules/myProfile/MyProfile")));
const EditMyProfile = Loadable(
  lazy(() => import("modules/myProfile/EditProfile"))
);

/** Change Password */
const ChangePasswordPage = Loadable(
  lazy(() => import("modules/changePassword/ChangePassword"))
);

/** UI Kit */
const UiKit = Loadable(lazy(() => import("modules/uiKit/UiKit")));
const UiTypography = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiTypograpgy"))
);
const UiColors = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiColors"))
);
const UiForms = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiForms"))
);
const UiCards = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiCards"))
);
const UiBlocks = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiBlocks"))
);
/** Property Management */
const Properties = Loadable(
  lazy(() => import("modules/property/properties/Properties"))
);
const AddNewProperty = Loadable(
  lazy(() =>
    import("modules/property/properties/AddProperty/AddPropertyDetails")
  )
);
const ViewPropertyDetails = Loadable(
  lazy(() => import("modules/property/properties/ViewPropertyDetails"))
);
const PropertyDividends = Loadable(
  lazy(() => import("modules/property/propertyDividends/PropertyDividends"))
);
const AddDividend = Loadable(
  lazy(() => import("modules/property/propertyDividends/AddDividend"))
);
const PropertyManagement = Loadable(
  lazy(() => import("modules/property/PropertyManagement"))
);
const PropertySalesNotification = Loadable(
  lazy(() =>
    import("modules/property/propertySaleNotification/PropertySaleNotification")
  )
);
const PropertySalesNotificationDetails = Loadable(
  lazy(() =>
    import(
      "modules/property/propertySaleNotification/SaleProceedNotificationsDetails"
    )
  )
);
const AddSaleProceedNotification = Loadable(
  lazy(() =>
    import(
      "modules/property/propertySaleNotification/AddSaleProceedNotifiation"
    )
  )
);
const SalesProceeds = Loadable(
  lazy(() => import("modules/property/salesProceeds/SalesProceeds"))
);
const AddSaleProceedDetail = Loadable(
  lazy(() => import("modules/property/salesProceeds/AddSaleProceedDetail"))
);
const SaleProceedDetail = Loadable(
  lazy(() => import("modules/property/salesProceeds/SaleProceedDetail"))
);
/** Gems Management */
const Gemstone = Loadable(
  lazy(() => import("modules/gemstones/gems/Gemstone"))
);
const GemsManagement = Loadable(
  lazy(() => import("modules/gemstones/GemsManagement"))
);
const GemsSalesNotification = Loadable(
  lazy(() => import("modules/gemstones/saleNotificatios/GemSaleNotification"))
);
const GemsSalesProceeds = Loadable(
  lazy(() => import("modules/gemstones/saleProceeds/GemSaleProceeds"))
);
const AddGemsDetails = Loadable(
  lazy(() => import("modules/gemstones/gems/AddGems/AddGemsDetails"))
);

//investment
const InvestmentProperties = Loadable(
  lazy(() =>
    import("modules/investments/investmentProperty/InvestmentProperties")
  )
);
const InvestmentPropertyDetails = Loadable(
  lazy(() => import("modules/investments/investmentProperty/InvesmentsDetails"))
);
const InvestmentGems = Loadable(
  lazy(() => import("modules/investments/investmentGems/InvestmentGems"))
);
const InvestmentManagement = Loadable(
  lazy(() => import("modules/investments/InvestmentManagement"))
);

//Transcations
const Deposits = Loadable(
  lazy(() => import("modules/transactions/deposits/Deposits"))
);
const DepositDetails = Loadable(
  lazy(() => import("modules/transactions/deposits/DepositsDetails"))
);
const Withdrawal = Loadable(
  lazy(() => import("modules/transactions/withdrawal/Withdrawal"))
);
const WithdrawalDetails = Loadable(
  lazy(() => import("modules/transactions/withdrawal/WithdrawalDetails"))
);
const ReferralRewards = Loadable(
  lazy(() => import("modules/transactions/referralRewards/ReferralRewards"))
);
const ReferralRewardsDetails = Loadable(
  lazy(() =>
    import("modules/transactions/referralRewards/ReferralRewardDetails")
  )
);
const TransactionManagement = Loadable(
  lazy(() => import("modules/transactions/TransactionsManagement"))
);

//exit window
const ExitWindowManagement = Loadable(
  lazy(() => import("modules/exitWindow/ExitWindowManagement"))
);
const AddEditExitWindow = Loadable(
  lazy(() => import("modules/exitWindow/exitWindowProperty/AddEditExitWindow"))
);
const ExitWindowProperties = Loadable(
  lazy(() =>
    import("modules/exitWindow/exitWindowProperty/ExitWindowProperties")
  )
);
const StakeSellRequests = Loadable(
  lazy(() =>
    import(
      "modules/exitWindow/exitWindowProperty/ExitWindowDetails/StakeSellRequests"
    )
  )
);
const ExitWindowBuyRequests = Loadable(
  lazy(() =>
    import(
      "modules/exitWindow/exitWindowProperty/ExitWindowDetails/StakePurchaseRequests"
    )
  )
);
const ExitWindowGems = Loadable(
  lazy(() => import("modules/exitWindow/exitWindowGems/ExitWindowGems"))
);

//Business User
const ViewIndividualUserDetails = Loadable(
  lazy(() =>
    import(
      "modules/userManagement/individualUserList/ViewIndividualUserDetails"
    )
  )
);

//contact Us
const ContactManagement = Loadable(
  lazy(() => import("modules/contactUs/ContactManagement"))
);
const ContactUs = Loadable(lazy(() => import("modules/contactUs/ContactUs")));
const ContactUsView = Loadable(
  lazy(() => import("modules/contactUs/ContactUsView"))
);

const ArchivedUsersList = Loadable(
  lazy(() => import("modules/userManagement/archiveUsers/archivedUsersList"))
);

const ReportsManagement = Loadable(
  lazy(() => import("modules/reports/ReportsManagement"))
);

const TransactionsReport = Loadable(
  lazy(() => import("modules/reports/TransactionsReport"))
);

const DailyUserReport = Loadable(
  lazy(() => import("modules/reports/DailyUsersReport"))
);

const MainRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <PrivateRoute>
      <Layout />
    </PrivateRoute>
  ),
  children: [
    // Dashboard
    {
      path: PATHS.DASHBOARD,
      element: <Dashboard />,
    },
    // Business User
    // {
    //   path: PATHS.USER,
    //   element: <UserManagement />,
    //   children: [
    //     {
    //       path: PATHS.BUSINESS_USER_LIST,
    //       element: (
    //         <RoleGaurd
    //           module="Business Users"
    //           permission="View"
    //           isRedirect
    //           redirectUrl="/"
    //         >
    //           <BusinessUserList />
    //         </RoleGaurd>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   path:
    //     PATHS.USER +
    //     "/" +
    //     PATHS.BUSINESS_USER_LIST +
    //     "/" +
    //     PATHS.VIEW +
    //     "/" +
    //     ":id",
    //   element: (
    //     <RoleGaurd
    //       module="Business Users"
    //       permission="View"
    //       isRedirect
    //       redirectUrl="/"
    //     >
    //       <ViewBusinessUserDetails />
    //     </RoleGaurd>
    //   ),
    // },
    // {
    //   path:
    //     PATHS.USER +
    //     "/" +
    //     PATHS.BUSINESS_USER_LIST +
    //     "/" +
    //     PATHS.PERSONAL_DETAILS +
    //     "/" +
    //     ":id" +
    //     "/" +
    //     ":personalId",
    //   element: (
    //     <RoleGaurd
    //       module="Business Users"
    //       permission="View"
    //       isRedirect
    //       redirectUrl="/"
    //     >
    //       <BusinessUserPersonalDetails />
    //     </RoleGaurd>
    //   ),
    // },
    // {
    //   path: PATHS.USER + "/" + PATHS.BUSINESS_USER_LIST + "/" + PATHS.CREATE,
    //   element: (
    //     <RoleGaurd
    //       module="Business Users"
    //       permission="Create"
    //       isRedirect
    //       redirectUrl="/"
    //     >
    //       <AddUser type="add" />
    //     </RoleGaurd>
    //   ),
    // },
    // {
    //   path: PATHS.USER + "/" + PATHS.BUSINESS_USER_LIST + "/" + PATHS.EDIT,
    //   element: (
    //     <RoleGaurd
    //       module="Business Users"
    //       permission="Edit"
    //       isRedirect
    //       redirectUrl="/"
    //     >
    //       <AddUser type="edit" />
    //     </RoleGaurd>
    //   ),
    // },
    // User management
    {
      path: PATHS.USER,
      element: <UserManagement />,
      children: [
        {
          // index: true,
          path: PATHS.USER_LIST,
          element: (
            <RoleGaurd
              module="Individual Users"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <UserList />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.USER_LIST + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoleGaurd
              module="Individual Users"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ViewIndividualUserDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.USER_LIST + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Individual Users"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AddUser type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.USER_LIST + "/" + PATHS.EDIT,
          element: (
            <RoleGaurd
              module="Individual Users"
              permission="Edit"
              isRedirect
              redirectUrl="/"
            >
              <AddUser type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER,
          element: (
            <RoleGaurd
              module="Admin Users"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <AdminUsers />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Admin Users"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AdminUserAdd type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Admin Users"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <AdminUserDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd
              module="Admin Users"
              permission="Edit"
              isRedirect
              redirectUrl="/"
            >
              <AdminUserEdit type="edit" />
            </RoleGaurd>
          ),
        },
        // {
        //   path: PATHS.ANY,
        //   element: <Navigate to={`${PATHS.USER}/${PATHS.ADMIN_USER}`} />,
        // },
      ],
    },

    //Property Management

    {
      path: PATHS.PROPERTY,
      element: <PropertyManagement />,
      children: [
        {
          // index: true,
          path: PATHS.PROPERTY_LIST,
          element: (
            <RoleGaurd
              module="Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <Properties />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_LIST + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Property"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AddNewProperty type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_LIST + "/" + PATHS.VIEW + "/:id",

          element: (
            <RoleGaurd
              module="Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ViewPropertyDetails type="view" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_DIVIDENDS,
          element: (
            <RoleGaurd
              module="Property Dividend"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <PropertyDividends />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_DIVIDENDS + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Property"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AddDividend />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_SALES_NOTIFICATION,
          element: (
            <RoleGaurd
              module="Property Sales Notification"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <PropertySalesNotification />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_SALES_NOTIFICATION + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Property Sales Notification"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <PropertySalesNotificationDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_SALES_NOTIFICATION + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Property Sales Notification"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AddSaleProceedNotification />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SALES_PROCEEDS,
          element: (
            <RoleGaurd
              module="Property Sales Proceed"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <SalesProceeds />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SALES_PROCEEDS + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Property Sales Proceed"
              permission="Create"
              isRedirect
              redirectUrl="/"
            >
              <AddSaleProceedDetail />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SALES_PROCEEDS + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Property Sales Proceed"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <SaleProceedDetail />
            </RoleGaurd>
          ),
        },
      ],
    },

    //Gems Management

    {
      path: PATHS.GEMS,
      element: <GemsManagement />,
      children: [
        {
          // index: true,
          path: PATHS.GEMS_LIST,
          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <Gemstone />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMS_LIST + "/" + PATHS.CREATE,

          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <AddGemsDetails type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMS_LIST + "/" + PATHS.VIEW,

          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ViewGemsDetails type="view" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMS_SALES_NOTIFICATION,
          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <GemsSalesNotification />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMS_SALES_PROCEEDS,
          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <GemsSalesProceeds />
            </RoleGaurd>
          ),
        },
      ],
    },

    //Investment
    {
      path: PATHS.INVESTMENT,
      element: <InvestmentManagement />,
      children: [
        {
          // index: true,
          path: PATHS.INVESTMENT_PROPERTY,
          element: (
            <RoleGaurd
              module="Investment: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <InvestmentProperties />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.INVESTMENT_PROPERTY + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoleGaurd
              module="Investment: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <InvestmentPropertyDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.INVESTMENT_GEMS,
          element: (
            <RoleGaurd
              module="Investment: Gems"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <InvestmentGems />
            </RoleGaurd>
          ),
        },
      ],
    },
    //transaction
    {
      path: PATHS.TRANSACTIONS,
      element: <TransactionManagement />,
      children: [
        {
          // index: true,
          path: PATHS.DEPOSITS,
          element: (
            <RoleGaurd
              module="Transactions: Deposits"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <Deposits />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.DEPOSITS + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Transactions: Deposits"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <DepositDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.WITHDRAWALS,
          element: (
            <RoleGaurd
              module="Transactions: Withdrawal"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <Withdrawal />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.WITHDRAWALS + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Transactions: Withdrawal"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <WithdrawalDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.REFERRAL_REWARDS,
          element: (
            <RoleGaurd
              module="Transactions: Referral Rewards"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ReferralRewards />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.REFERRAL_REWARDS + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Transactions: Referral Rewards"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ReferralRewardsDetails />
            </RoleGaurd>
          ),
        },
      ],
    },
    //EXIT WINDOW
    {
      path: PATHS.EXIT_WINDOW,
      element: <ExitWindowManagement />,
      children: [
        {
          path: PATHS.EXIT_WINDOW_PROPERTY,
          element: (
            <RoleGaurd
              module="Exit Window: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ExitWindowProperties />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EXIT_WINDOW_PROPERTY + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd
              module="Exit Window: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <StakeSellRequests />
            </RoleGaurd>
          ),
        },
        {
          path:
            PATHS.EXIT_WINDOW_PROPERTY_BUYER +
            "/" +
            PATHS.VIEW +
            "/:id/:exitId",
          element: (
            <RoleGaurd
              module="Exit Window: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ExitWindowBuyRequests />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EXIT_WINDOW_PROPERTY + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd
              module="Exit Window: Property"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <AddEditExitWindow />
            </RoleGaurd>
          ),
        },

        {
          path: PATHS.EXIT_WINDOW_GEMS,
          element: (
            <RoleGaurd
              module="User"
              permission="View"
              isRedirect
              redirectUrl="/"
            >
              <ExitWindowGems />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Content management
    {
      path: PATHS.CONTENT,
      element: <ContentManagement />,
      children: [
        // Static Pages
        {
          path: PATHS.CMS_PAGES,
          element: (
            <RoleGaurd module="CMS Pages" permission="View">
              <StaticPages />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CMS_PAGES + "/" + PATHS.VIEW,
          element: (
            <RoleGaurd module="CMS Pages" permission="View">
              <StatisPagesViewDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CMS_PAGES + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="CMS Pages" permission="Create">
              <AddStaticPage type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CMS_PAGES + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoleGaurd module="CMS Pages" permission="Edit">
              <AddStaticPage type="edit" />
            </RoleGaurd>
          ),
        },

        // Faqs
        {
          path: PATHS.FAQS,
          element: (
            <RoleGaurd module="FAQs" permission="View">
              <FaqsPage />
            </RoleGaurd>
          ),
          children: [
            {
              path: PATHS.FAQS_LIST,
              element: (
                <RoleGaurd module="FAQs" permission="View">
                  <FaqsList />
                </RoleGaurd>
              ),
            },
            {
              path: PATHS.FAQS_LIST + "/" + PATHS.EDIT + "/:Id",
              element: (
                <RoleGaurd module="FAQs" permission="Edit">
                  <AddFaq type="edit" />
                </RoleGaurd>
              ),
            },
            {
              path: PATHS.FAQS_LIST + "/" + PATHS.CREATE,
              element: (
                <RoleGaurd module="FAQs" permission="Create">
                  <AddFaq type="add" />
                </RoleGaurd>
              ),
            },
            {
              path: "",
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`}
                />
              ),
            },
            {
              path: PATHS.ANY,
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`}
                />
              ),
            },
          ],
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.CONTENT}/${PATHS.CMS_PAGES}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.CONTENT}/${PATHS.CMS_PAGES}`} />,
        },
      ],
    },

    // Role
    {
      path: PATHS.ROLE,
      element: <RoleManagement />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd module="Role" permission="View">
              <RolePage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoleGaurd module="Role" permission="Create">
              <AddEditRole type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Role" permission="Edit">
              <AddEditRole type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW + "/" + ":id",
          element: (
            <RoleGaurd module="Role" permission="View">
              <ViewRole type="view" />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Email And Notifications
    {
      path: PATHS.EMAIL_TEMPLATES,
      element: <EmailTemplatesManagement />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd module="Email Template" permission="View">
              <EmailTemplates />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoleGaurd module="Email Template" permission="Create">
              <AddEditTemplates type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EDIT,
          element: (
            <RoleGaurd module="Email Template" permission="Edit">
              <AddEditTemplates type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW,
          element: (
            <RoleGaurd module="Email Template" permission="View">
              <ViewTemplates type="view" />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Reports
    {
      path: PATHS.REPORTS,
      element: <ReportsManagement />,
      children: [
        {
          path: PATHS.DAILY_USER_REPORT,
          element: (
            <RoleGaurd module="Report: User Report" permission="View">
              <DailyUserReport />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.TRANSACTION_REPORT,
          element: (
            <RoleGaurd
              module="Transactions: Referral Rewards"
              permission="View"
            >
              <TransactionsReport />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Lesg Logs
    {
      path: PATHS.LESG_LOGS,
      element: <LesgLogs />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd>
              <LesgLogs />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoleGaurd>
              <AddLogs type="add" />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Master Management
    {
      path: PATHS.MASTER_MANAGEMENT,
      element: <MasterManagement />,
      children: [
        {
          path: PATHS.COUNTRY,
          element: (
            <RoleGaurd module="Master: Country" permission="View">
              <CountryPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.COUNTRY + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Country" permission="Create">
              <AddCountry type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.TIMEZONE,
          element: (
            <RoleGaurd module="Master: Timezone" permission="View">
              <TimezonePage />
            </RoleGaurd>
          ),
        },

        {
          path: PATHS.LANGUAGE,
          element: (
            <RoleGaurd module="Master: Language" permission="View">
              <LanguagePage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.LANGUAGE + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Language" permission="Create">
              <AddLanguage type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: "",
          element: (
            <Navigate to={`${PATHS.MASTER_MANAGEMENT}/${PATHS.COUNTRY}`} />
          ),
        },
        {
          path: PATHS.ANY,
          element: (
            <Navigate to={`${PATHS.MASTER_MANAGEMENT}/${PATHS.COUNTRY}`} />
          ),
        },
        {
          path: PATHS.AMENITIES,
          element: (
            <RoleGaurd module="Master: Amenities" permission="View">
              <AmenitiesPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.AMENITIES + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Amenities" permission="Create">
              <AddAmenities type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.AMENITIES + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Master: Amenities" permission="Edit">
              <AddAmenities type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMSTONE_TYPE,
          element: (
            <RoleGaurd module="Master: Gemstone Type" permission="View">
              <GemstoneTypePage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMSTONE_TYPE + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Gemstone Type" permission="Create">
              <AddGemstoneType type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.GEMSTONE_TYPE + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Master: Gemstone Type" permission="Edit">
              <AddGemstoneType type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SUBSIDARIES,
          element: (
            <RoleGaurd module="Master: Subsidiary" permission="View">
              <SubsidiariesPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SUBSIDARIES + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Subsidiary" permission="Create">
              <AddSubsidiaries type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SUBSIDARIES + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Master: Subsidiary" permission="Edit">
              <AddSubsidiaries type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ANY,
          element: (
            <Navigate to={`${PATHS.MASTER_MANAGEMENT}/${PATHS.AMENITIES}`} />
          ),
        },
        {
          path: PATHS.INDUSTRIES,
          element: (
            <RoleGaurd module="Master: Industry" permission="View">
              <IndustryPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.INDUSTRIES + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd module="Master: Industry" permission="Create">
              <AddIndustry type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.INDUSTRIES + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoleGaurd module="Master: Industry" permission="Edit">
              <AddIndustry type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ROLES_LIST, // should be 'role' not '/role'
          element: (
            <RoleGaurd module="Master: Employment Role" permission="View">
              <RoleListPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ROLES_LIST + "/" + PATHS.CREATE, // should be 'role/create'
          element: (
            <RoleGaurd module="Master: Employment Role" permission="Create">
              <AddRole type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.ROLES_LIST + "/" + PATHS.EDIT + "/:id", // should be 'role/edit/:id'
          element: (
            <RoleGaurd module="Master: Employment Role" permission="Edit">
              <AddRole type="edit" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PROPERTY_TYPE, // should be 'property-type' not '/property-type'
          element: (
            <RoleGaurd module="Master: Property Type" permission="View">
              <PropertyTypePage />
            </RoleGaurd>
          ),
        },

        {
          path: PATHS.PROPERTY_TYPE + "/" + PATHS.CREATE, // should be 'property-type/create'
          element: (
            <RoleGaurd module="Master: Property Type" permission="Create">
              <AddPropertyType type="add" />
            </RoleGaurd>
          ),
        },

        {
          path: PATHS.PROPERTY_TYPE + "/" + PATHS.EDIT + "/:id", // should be 'property-type/edit/:id'
          element: (
            <RoleGaurd module="Master: Property Type" permission="Edit">
              <AddPropertyType type="edit" />
            </RoleGaurd>
          ),
        },
      ],
    },
    // Support
    //Contact Us
    {
      path: PATHS.CONTACT_US,
      element: <ContactManagement />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd module="Contact Us" permission="View">
              <ContactUs />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd module="Contact Us" permission="View">
              <ContactUsView type="view" />
            </RoleGaurd>
          ),
        },
      ],
    },

    {
      path: PATHS.SUPPORT,
      element: <SupportManagement />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd>
              <Support />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.VIEW + "/:id",
          element: (
            <RoleGaurd>
              <TicketDetail />
            </RoleGaurd>
          ),
        },
      ],
    },

    // Settings
    {
      path: PATHS.SETTINGS,
      element: <Settings />,
      children: [
        {
          path: PATHS.GENERAL_SETTINGS,
          element: (
            <RoleGaurd module="Configurations" permission="View">
              <GeneralSettings />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.NOTIFICATIONS,
          element: (
            <RoleGaurd module="Notification" permission="View">
              <NotificationsPage />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.EMAIL_NOTIFICATIONS,
          element: (
            <RoleGaurd module="Notification" permission="View">
              <EmailNotifications />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.PAYMENT_GATEWAY,
          element: (
            <RoleGaurd>
              <PaymentGateway />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SMTP_SMS_DETAILS,
          element: (
            <RoleGaurd>
              <SmtpSmsDetails />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.SOCIAL_MEDIA,
          element: (
            <RoleGaurd>
              <SocialMedia />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.LANGUAGE_MESSAGES,
          element: (
            <RoleGaurd>
              <LanguageMessages />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.LANGUAGE_MESSAGES + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd>
              <AddLanguageMessages type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.LANGAUGE_STATIC_LANG,
          element: (
            <RoleGaurd>
              <LangaugeStaticLang />
            </RoleGaurd>
          ),
        },
        {
          path: PATHS.LANGAUGE_STATIC_LANG + "/" + PATHS.CREATE,
          element: (
            <RoleGaurd>
              <AddLanguageStaticLang type="add" />
            </RoleGaurd>
          ),
        },
        {
          path: "",
          element: (
            <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />
          ),
        },
        {
          path: PATHS.ANY,
          element: (
            <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />
          ),
        },
      ],
    },
    // Common Pages
    {
      path: PATHS.FourZeroFour,
      element: <FourZeroFourPage />,
    },
    {
      path: PATHS.THANKYOU,
      element: <ThankyouPage />,
    },
    {
      path: PATHS.COMING_SOON,
      element: <ComingSoonPage />,
    },
    // My Profile
    {
      path: PATHS.MY_PROFILE,
      element: <MyProfile />,
    },
    {
      path: PATHS.EDIT_MY_PROFILE,
      element: <EditMyProfile />,
    },
    {
      path: PATHS.CHANGE_PASSWORD,
      element: <ChangePasswordPage />,
    },
    // Archive Users
    {
      path: PATHS.ARCHIVED,
      element: <ArchivedUsersList />,
      children: [
        {
          path: "",
          element: (
            <RoleGaurd module="Archive Users" permission="View">
              <ArchivedUsersList />
            </RoleGaurd>
          ),
        },
      ],
    },
    // UI Kit
    {
      path: PATHS.UI_KIT,
      element: (
        <UiKitLayout>
          <UiKit />
        </UiKitLayout>
      ),
      exact: true,
      children: [
        {
          path: PATHS.TYPOGRAPHY,
          element: <UiTypography />,
        },
        {
          path: PATHS.COLORS,
          element: <UiColors />,
        },
        {
          path: PATHS.FORMS,
          element: <UiForms />,
        },
        {
          path: PATHS.CARDS,
          element: <UiCards />,
        },
        {
          path: PATHS.BLOCKS,
          element: <UiBlocks />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={PATHS.UI_KIT} />,
        },
      ],
    },
  ],
};

const AuthenticationRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <GuestRoute>
      <AuthLayout />
    </GuestRoute>
  ),
  children: [
    {
      path: PATHS.DEFAULT,
      element: <Login />,
    },
    {
      path: PATHS.OTP_DETAILS,
      element: <OtpDetails />,
    },
    {
      path: PATHS.OTP_VERIFICATION,
      element: <OtpVerification />,
    },
    {
      path: PATHS.FORGOT_PASSWORD,
      element: <ForgotPassword />,
    },
    {
      path: PATHS.DELETE_ACCOUNT,
      element: <DeleteAccount />,
    },
    {
      path: PATHS.RESET_PASSWORD,
      element: <ResetPassword />,
    },
  ],
};

// Standalone Privacy Policy Route (without AuthLayout)
const PrivacyPolicyRoute = {
  path: PATHS.PRIVACY_POLICY,
  element: <PrivacyPolicy />,
};

// Standalone Terms and Conditions Route (without AuthLayout)
const TermsAndConditionsRoute = {
  path: PATHS.TERMS_CONDITIONS,
  element: <TermsAndConditions />,
};

/**
 * @params {boolean}
 * @return {Array} of all paths & routes
 */
export const getRoutes = () => [
  AuthenticationRoutes,
  MainRoutes,
  PrivacyPolicyRoute,
  TermsAndConditionsRoute,
  {
    path: PATHS.ANY,
    element: <FourZeroFourPage />,
  },
];
